import React, { useEffect, useState, useContext } from "react";
import { AuthContext } from "../context/AuthContext";
import { useNavigate } from "react-router-dom";

const AdminSaques = () => {
  const { user } = useContext(AuthContext);
  const [saques, setSaques] = useState([]);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    if (!user || user.role !== "admin") {
      alert("Acesso negado! Somente administradores podem ver esta página.");
      navigate("/");
      return;
    }

    const fetchSaquesPendentes = async () => {
      try {
        const token = localStorage.getItem("token");

        if (!token) {
          alert("Sessão expirada. Faça login novamente.");
          navigate("/login");
          return;
        }

        const response = await fetch(`${process.env.REACT_APP_API_URL}/api/admin/saques/pendentes`, {
          headers: { Authorization: `Bearer ${token}` },
        });

        if (!response.ok) {
          throw new Error(`Erro HTTP ${response.status}`);
        }

        const data = await response.json();
        setSaques(Array.isArray(data) ? data : []);
      } catch (error) {
        console.error("Erro ao buscar saques pendentes:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchSaquesPendentes();
  }, [user, navigate]);

  const confirmarSaquePix = async (transacaoId, userId) => {
    try {
      const token = localStorage.getItem("token");
  
      // 1. Realiza o Pix normalmente
      const pagar = await fetch(`${process.env.REACT_APP_API_URL}/api/carteira/saque/pagar`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify({ transacaoId, userId }),
      });
  
      if (pagar.ok) {
        // 2. Atualiza o status para "confirmado"
        await fetch(`${process.env.REACT_APP_API_URL}/api/admin/saques/confirmar`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
          body: JSON.stringify({ transacaoId, userId }),
        });
  
        // 3. Atualiza visualmente a lista de saques (sem alertas)
        setSaques((prev) => prev.filter((s) => s.id !== transacaoId));
      } else {
        const data = await pagar.json();
        console.error("Erro ao autorizar saque:", data.error);
      }
    } catch (error) {
      console.error("Erro ao confirmar saque:", error);
    }
  };

  const rejeitarSaque = async (transacaoId, userId) => {
    try {
      const token = localStorage.getItem("token");

      const response = await fetch(`${process.env.REACT_APP_API_URL}/api/carteira/saque/rejeitar`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify({ transacaoId, userId }),
      });

      if (response.ok) {
        alert("Saque rejeitado com sucesso.");
        setSaques((prev) => prev.filter((s) => s.id !== transacaoId));
      } else {
        const errorData = await response.json();
        alert(`Erro ao rejeitar saque: ${errorData.error}`);
      }
    } catch (error) {
      console.error("Erro ao rejeitar saque:", error);
    }
  };

  return (
    <div className="container mx-auto p-4">
      <h2 className="text-2xl font-bold mb-4">Saques Pendentes</h2>

      {loading ? (
        <p>Carregando...</p>
      ) : saques.length === 0 ? (
        <p>Nenhum saque pendente.</p>
      ) : (
        <table className="w-full border-collapse border border-gray-300">
          <thead>
            <tr className="bg-gray-200">
              <th className="border border-gray-300 p-2">ID</th>
              <th className="border border-gray-300 p-2">Usuário</th>
              <th className="border border-gray-300 p-2">Nome</th>
              <th className="border border-gray-300 p-2">Tracking ID</th>
              <th className="border border-gray-300 p-2">Valor</th>
              <th className="border border-gray-300 p-2">Chave Pix</th>
              <th className="border border-gray-300 p-2">Ação</th>
            </tr>
          </thead>
          <tbody>
            {saques.map((saque) => (
              <tr key={saque.id} className="hover:bg-gray-100">
                <td className="border border-gray-300 p-2">{saque.id}</td>
                <td className="border border-gray-300 p-2">{saque.userId}</td>
                <td className="border border-gray-300 p-2">{saque.nome || "—"}</td>
                <td className="border border-gray-300 p-2">{saque.trackingId || "—"}</td>
                <td className="border border-gray-300 p-2">R$ {saque.valor.toFixed(2)}</td>
                <td className="border border-gray-300 p-2">{saque.chavePix}</td>
                <td className="border border-gray-300 p-2 flex gap-2">
                  <button
                    onClick={() => confirmarSaquePix(saque.id, saque.userId)}
                    className="bg-green-500 text-white px-3 py-1 rounded hover:bg-green-700"
                  >
                    Confirmar
                  </button>
                  <button
                    onClick={() => rejeitarSaque(saque.id, saque.userId)}
                    className="bg-red-500 text-white px-3 py-1 rounded hover:bg-red-700"
                  >
                    Rejeitar
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
    </div>
  );
};

export default AdminSaques;
